import { NgModule } from '@angular/core';
import * as moment from 'moment';


declare var $: any;

@NgModule({})
export class DateUtil {
  
  public static checkDtFim(event, finalDate: Date) {
    if (moment(event) > moment(finalDate)) {
      finalDate = null;
    }
  }

  public static dateFormat(data): string {
    var retorno = "";
    var retornoVet = (data + "").split("-");
    if (retornoVet.length == 3) {
      retorno += retornoVet[2] + "/" + retornoVet[1] + "/" + retornoVet[0];
    }
    return retorno;
  }

  public static calcQtsHourRow(date1: Date, date2: Date): string {
    if (date2 != null && date1 != null) {
      var diffMs = (date2.getTime() - date1.getTime());
      var diffHrs = Math.floor((diffMs % 86400000) / 3600000);
      var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
      var diffDays = this.diffDays(date1, date2);
      if (diffMins < 60) {
        return this.completaZero((diffDays * 24) + diffHrs) + ':' + this.completaZero(diffMins);
      }
      else {
        return this.completaZero((diffDays * 24) + diffHrs + 1) + ':' + this.completaZero(diffMins - 60);
      }
    }
    return "00:00";
  }

  public static formatDateTimeZone(data: Date): string {
    var isoDate = new Date(data.getTime() - (data.getTimezoneOffset() * 60000)).toISOString();
    return isoDate;
  }
  
  public static calcQtsHour(date1: Date, date2: Date): string {
    if (date2 != null && date1 != null) {
      var diffMs = (date2.getTime() - date1.getTime());
      var diffHrs = Math.floor((diffMs % 86400000) / 3600000);
      var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
      var diffDays = this.diffDays(date1, date2);
      if (diffMins < 60) {
        return this.completaZero((diffDays * 24) + diffHrs) + ':' + this.completaZero(diffMins);
      }
      else {
        return this.completaZero((diffDays * 24) + diffHrs + 1) + ':' + this.completaZero(diffMins - 60);
      }
    }
    return "00:00";
  }

  public static diffDays(date1: Date, date2: Date): number {
    const init = moment(date1);
    const end = moment(date2);
    const duration = moment.duration(init.diff(end));
    const days = Math.abs(Math.trunc(duration.asDays()));
    return days;
  }

  public static sameDays(date1: Date, date2: Date): boolean {
    var sameyear = date1.getFullYear() == date2.getFullYear();
    var samemonth = date1.getMonth() == date2.getMonth();
    var sameday = date1.getDate() == date2.getDate();
    if (sameyear && samemonth && sameday) {
      return true;
    }
    else {
      return false;
    }
  }

  //data = ANO-MES-DIA
  //hora = HOR:MIN:SEG
  public static dateTypeFormat(dataStr: string, hourStr: string): string {
    var data = this.newDate(dataStr, hourStr)
    var retorno = this.completaZero(data.getDate()) + "/" + this.completaZero(data.getMonth() + 1) + "/" + data.getFullYear() + " " + this.completaZero(data.getHours()) + ":" + this.completaZero(data.getMinutes());
    return retorno;
  }

  //data = ANO-MES-DIATHOR:MIN:SEG
  public static dateTypeFormatedStr(dataStr: string): string {
    var splited = dataStr.split('T');
    var data = this.newDate(splited[0], splited[1])
    var retorno = this.completaZero(data.getDate()) + "/" + this.completaZero(data.getMonth() + 1) + "/" + data.getFullYear() + " " + this.completaZero(data.getHours()) + ":" + this.completaZero(data.getMinutes());
    return retorno;
  }

  public static dateTypeFormatStr(data: Date, hour: number): string {
    data.setTime(hour);
    var retorno = this.completaZero(data.getDate()) + "/" + this.completaZero(data.getMonth() + 1) + "/" + data.getFullYear() + " " + this.completaZero(data.getHours()) + ":" + this.completaZero(data.getMinutes());
    return retorno;
  }

  public static dateTypeFormatStr2(data: Date): string {
    var retorno = this.completaZero(data.getDate()) + "/" + this.completaZero(data.getMonth() + 1) + "/" + data.getFullYear() + " " + this.completaZero(data.getHours()) + ":" + this.completaZero(data.getMinutes());
    return retorno;
  }

  //data = ANO-MES-DIA
  //hora = HOR:MIN:SEG
  public static newDate(data: string, hour: string): Date {
    var retorno: Date;
    var retornoVet = (data + "").split("-");
    if (retornoVet.length == 3) {
      retorno = new Date(data + 'T' + hour);
    }
    return retorno;
  }

  public static newDateOutHour(data: string): Date {
    var retorno: Date;
    var retornoVet = (data + "").split("-");
    if (retornoVet.length == 3) {
      retorno = new Date(data + 'T00:00:00');
    }
    return retorno;
  }

  public static completaZero(number): string {
    var retorno = "";
    if (number <= 9) {
      retorno += "0";
    }
    retorno += number;
    return retorno;
  }

  public static betweenDate(initialDateNew: Date, finishDateNew: Date, initialDateIn: Date, finishDateIn: Date): boolean {
    var between = true;
    if (initialDateIn > initialDateNew) {
      if (initialDateIn > finishDateNew) {
        between = false;
      }
    }
    else if (initialDateIn < initialDateNew && initialDateIn < finishDateNew) {
      if (finishDateIn < initialDateNew && finishDateIn < finishDateNew) {
        between = false;
      }
    }
    else {
      between = true;
    }
    return between
  }

  public static getHourStr(data: Date): string {
    return this.completaZero(data.getHours()) + ":" + this.completaZero(data.getMinutes()) + ":" + this.completaZero(data.getSeconds());
  }

  public static getDateStr(data: Date): string {
    return this.completaZero(data.getFullYear()) + "-" + this.completaZero(data.getMonth() + 1) + "-" + this.completaZero(data.getDate());
  }

  public static changeDateForNumber(n: Date): number {
    var start = new Date('1900-12-31');
    var retorno = (n.getTime() - start.getTime())/(1000 * 60 * 60 * 24)// + 2;
    return retorno
  }

  public static changeNumberForDate(n: number): any {
    if (n != null && n != undefined) {
      var exdate = n + 365; // represents Jan 1, 1993
      var e0date = new Date(0); // epoch "zero" date
      var offset = e0date.getTimezoneOffset(); // tz offset in min
      var jsdate = new Date(0, 0, exdate, 0, -offset - 1 + 365, 0);

      return jsdate
    }
    else return null;
  }

  public static isNumber(n): boolean {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  public static isDate(n): boolean {
    return n instanceof Date && !isNaN(n.valueOf());
  }

  public static calcTime(time: string, total: string): string {
    var [hours, minutes, seconds] = time.split(':');
    var [totalHours, totalMinutes, totalSeconds] = total.split(':');

    var hrs = parseInt(hours) + parseInt(totalHours);
    var min = parseInt(minutes) + parseInt(totalMinutes);
    var sec = parseInt(seconds) + parseInt(totalSeconds);

    min += Math.floor(sec / 60);
    hrs += Math.floor(min / 60);
    
    min = min % 60;
    sec = sec % 60;

    return this.completaZero(hrs) + ":" + this.completaZero(min) + ":" + this.completaZero(sec);
  }

  //time = 00:00:00 -> return = 00:00
  public static formatTimeHHMM(time: string): string {
    if(time != null && time.includes(":")) {
      var timeSplit = time.split(':');
      return timeSplit[0] + ":" + timeSplit[1];
    }
    else {
      return "";
    }
  }

  //data = ANO-MES-DIA
  public static olderDate(date1: string, date2: string): string {
    var [year1, month1, day1] = (date1).split("-");
    var [year2, month2, day2] = (date2).split("-");

    if(year1 == year2) {
      if(month1 == month2) {
        if(day1 < day2) return date1;
      }
      else if(month1 < month2) return date1;
    }
    else if(year1 < year2) return date1;

    return date2;
  }

  //time = 00:00:00
  public static olderTime(time1: string, time2: string): string {
    var [hour1, min1, sec1] = (time1).split(":");
    var [hour2, min2, sec2] = (time2).split(":");

    if(hour1 == hour2) {
      if(min1 == min2) {
        if(sec1 < sec2) return time1;
      }
      else if(min1 < min2) return time1;
    }
    else if(hour1 < hour2) return time1;

    return time2;
  }

  //data = ANO-MES-DIA
  public static newerDate(date1: string, date2: string): string {
    var [year1, month1, day1] = (date1).split("-");
    var [year2, month2, day2] = (date2).split("-");

    if(year1 == year2) {
      if(month1 == month2) {
        if(day1 > day2) return date1;
      }
      else if(month1 > month2) return date1;
    }
    else if(year1 > year2) return date1;

    return date2;
  }

  //time = 00:00:00
  public static newerTime(time1: string, time2: string): string {
    var [hour1, min1, sec1] = (time1).split(":");
    var [hour2, min2, sec2] = (time2).split(":");

    if(hour1 == hour2) {
      if(min1 == min2) {
        if(sec1 > sec2) return time1;
      }
      else if(min1 > min2) return time1;
    }
    else if(hour1 > hour2) return time1;

    return time2;
  }
}

